import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { withTranslation } from "react-i18next";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

function PreviewTermsConditions(props) {
  const [numPages, setNumPages] = useState(0);
  const [width, setWidth] = useState(300);

  function onDocumentLoadSuccess({ numPages }) {
    const parentDiv = document.querySelector("#pdfDocument");
    setNumPages(numPages);
    setWidth(parentDiv.clientWidth);
  }

  return (
    <div>
      <div style={props.cardStyle} className={props.className}>
        <div id="pdfDocument" data-testid="pdfDocument">
          <Document
            file={props.file}
            onLoadSuccess={onDocumentLoadSuccess}
            noData={
              <h4 id="docNotFound">
                {props.t("AcceptTermsConditions.docNotFound")}
              </h4>
            }
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                width={width}
                pageNumber={index + 1}
                className="pdfPage"
                renderMode="svg"
              />
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
}

export default withTranslation("emp")(PreviewTermsConditions);
